import { useSearchParams } from 'next/navigation';
import classNames from 'classnames';
import { FILTER_OPTION_KEY, FilterOption } from './multilevel-filters-types';
import styles from './multilevel-filters.module.scss';

type FilterOptionButtonProps = {
  filterOptions: FilterOption[];
  handleFilterOptionClick: (filterOption: FilterOption) => void;
};

const FilterOptionButton = ({
  filterOptions,
  handleFilterOptionClick,
}: FilterOptionButtonProps) => {
  const searchParams = useSearchParams();

  if (!filterOptions?.length) return null;

  return (
    <div className={styles.filterOptionButtonContainer}>
      <ul className={styles.filterOptionList}>
        {filterOptions.map((filterOption) => (
          <li key={filterOption?.$unique_key} className={styles.filterListItem}>
            <button
              className={classNames([
                styles.filterOptionButton,
                {
                  [styles.activeOption]: searchParams.has(
                    FILTER_OPTION_KEY,
                    filterOption?.optionValue
                  ),
                },
              ])}
              type="button"
              onClick={() => handleFilterOptionClick(filterOption)}
            >
              {filterOption.optionName}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterOptionButton;
